import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Services = lazy(() => import('../pages/services/page'));
const Physicians = lazy(() => import('../pages/physicians/page'));
const DoctorsOrder = lazy(() => import('../pages/doctors-order/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const ReferralForm = lazy(() => import('../pages/referral-form/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Helper function to wrap lazy components in Suspense
const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div>Loading...</div>}>
    {children}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LazyWrapper><Home /></LazyWrapper>
  },
  {
    path: '/services',
    element: <LazyWrapper><Services /></LazyWrapper>
  },
  {
    path: '/physicians',
    element: <LazyWrapper><Physicians /></LazyWrapper>
  },
  {
    path: '/doctors-order',
    element: <LazyWrapper><DoctorsOrder /></LazyWrapper>
  },
  {
    path: '/referralform',
    element: <LazyWrapper><ReferralForm /></LazyWrapper>
  },
  {
    path: '/about',
    element: <LazyWrapper><About /></LazyWrapper>
  },
  {
    path: '/contact',
    element: <LazyWrapper><Contact /></LazyWrapper>
  },
  {
    path: '*',
    element: <LazyWrapper><NotFound /></LazyWrapper>
  }
];

export default routes;
